import React from 'react';
import * as _ from 'lodash';
import EventMg from '../utilities/EventManager';
import { FIELD_TREE_EVENTS } from '../components/FieldTreeEvents';
import Switch from './Switch';
import { QuestionIcon } from './icons/QuestionIcon';
import Tippy from '../components/ReactTippy';

export default class FieldTreeLabel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      labels: [
        { name: '1次' },
        { name: '2次' },
        { name: '3次' },
        { name: '4次' },
        { name: '5次' },
      ],
      partner: [],
    };
    this.scroller = null;
    EventMg.addEventListener(FIELD_TREE_EVENTS.TREE_LOADED, data => {
      let _partner = [];
      _.each(data, (val, key) => {
        if (key.match(/^partner(_[1-5])/)) {
          _partner.push(_.merge({ name: key }, val));
        }
      });
      this.setState(
        {
          partner: _partner,
        },
        () => {
          if (_.isFunction(this.props.setHasPartners)) {
            this.props.setHasPartners(!_.isEmpty(this.state.partner));
          }
        }
      );
    });
  }

  componentWillUnmount() {
    EventMg.deleteEvent(FIELD_TREE_EVENTS.TREE_LOADED);
  }

  GetItems() {
    return _.map(this.state.partner, (val, key) => {
      return (
        <div key={key} className='fieldstree-label__item'>
          <span className='fieldstree-label__item-label'>
            {this.state.labels[key].name}{' '}
          </span>
          <span className='fieldstree-label__item-counter'>
            {val.results}/{val.total}
          </span>
        </div>
      );
    });
  }

  render() {
    return (
      <div className='fieldstree__labels'>
        <div
          id='fieldstree-label'
          className='fieldstree-label'
          style={{ position: 'relative' }}
        >
          {this.GetItems()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FieldTreeLabel.jsx